import { fileTypeFromBlob, FileTypeResult } from '../../utils/fileType';

export const fileMatchesFileType = (file: File, fileType: FileTypeResult): boolean => {
  const fileExt = file.name.split('.').pop()?.toLocaleLowerCase(); // get substring after last '.'
  if (fileExt !== fileType.ext) {
    // special case for jpeg/jpg handling
    if (fileExt === 'jpeg' && fileType.ext === 'jpg' && fileType.mime === 'image/jpeg') {
      return true;
    }
    return false;
  }
  if (file.type !== fileType.mime) return false;
  return true;
};

export const fileContentsDoNotMatchExtension = async (files: File[]): Promise<boolean> => {
  const fileCheckPromises = files.map(async (file) => {
    const fileType = await fileTypeFromBlob(file);
    return fileType ? fileMatchesFileType(file, fileType) : false;
  });
  const fileCheckResults = await Promise.all(fileCheckPromises);
  return fileCheckResults.some((res) => res === false);
};
